<template>
  <section v-if="results">
    <ul role="list" class="divide-y divide-gray-200">
      <InvitationListItem li v-for="i in records" :key="i.id" :invitation="i" as="li" />
    </ul>
  </section>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useFetchResources } from '@/client/actions';

const props = defineProps({podcast: Object});
const router = useRouter();

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/invitations');
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const pending = (invitation) => ! invitation.converted;
const records = computed(() => results.value.filter(pending));

const watcher = watch(target, (v, _) => fetch());
const mounted = onMounted(() => fetch());
</script>
